<template>
  <div class="p-layout">
    <a @click="clickHandle(index - 1)"></a><a @click="clickHandle(1)" :class="{ active: index === 1 }">1</a><a class="more" @click="clickHandle(index - 3)" v-if="index >= 4">...</a><a
      v-for="page in pages"
      :key="page"
      @click="clickHandle(page)"
      :class="{ active: index === page }"
      >{{ page }}</a
    ><a
      class="more"
      @click="clickHandle(pages[pages.length - 1] + 2)"
      v-if="pages[pages.length - 1] + 2 <= maxPage"
      >...</a
    ><a
      @click="clickHandle(maxPage)"
      v-if="maxPage !== 1"
      :class="{ active: index === maxPage }"
      >{{ maxPage }}</a
    >
    <a @click="clickHandle(index + 1)"></a>
  </div>
</template>

<script>
/**
 * 取得页码数组
 * @param showPageMaxCount 允许显示的页码最大数量
 * @param pageNow 当前页码
 * @param pageCount 总页数
 * @return 页码数组（整数数组）
 */
function getPageNumArr(showPageMaxCount, pageNow, pageCount) {
  let pageNumArr = [];
  let pageNumBegin, pageNumEnd;

  if (pageCount <= showPageMaxCount) {
    pageNumBegin = 1;
    pageNumEnd = pageCount;
  } else {
    if (pageNow <= Math.floor(showPageMaxCount / 2)) {
      pageNumBegin = 1;
      pageNumEnd = showPageMaxCount;
    } else if (pageCount - pageNow <= Math.floor(showPageMaxCount / 2)) {
      pageNumBegin = pageCount - showPageMaxCount;
      pageNumEnd = pageCount;
      pageNumEnd - pageNumBegin >= showPageMaxCount && pageNumBegin++;
    } else {
      pageNumBegin = Math.ceil(pageNow - showPageMaxCount / 2);
      pageNumEnd = Math.floor(pageNow + showPageMaxCount / 2);
      pageNumEnd - pageNumBegin >= showPageMaxCount && pageNumBegin++;
    }
  }
  for (let i = pageNumBegin; i <= pageNumEnd; i++) {
    pageNumArr.push(i);
  }

  return pageNumArr;
}

export default {
  props: {
    current: {
      default: 1,
    },
    reindex: {
      default: 1,
    },
    total: {
      default: 10,
    },
    equable: {
      default: 10,
    },
    length: {
      default: 5,
    },
    value: {
      default: 1,
    },
    color: {
      default: "#2d2d2d",
    },
  },
  data() {
    return { index: this.value };
  },
  mounted() {
    this.$emit("maxPage", this.maxPage);
  },
  computed: {
    maxPage() {
      let val = Math.ceil(this.total / this.equable);
      this.$emit("maxPage", val);
      return val;
    },
    pages() {
      let temp = getPageNumArr(this.length, this.index, this.maxPage);
      // v-if="page!==maxPage && page!==1"
      temp.shift();
      temp.pop();
      return temp;
    },
  },
  methods: {
    clickHandle(index) {
      if (index > 0 && index <= this.maxPage) {
        this.index = index;
      }
      this.$emit("clickHandle", this.index);
    },
  },
  watch: {
    index() {
      // this.$bus.$emit("input", newVal);
    },
    current(newVal) {
      this.index = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
@theme: #a61f24;
.p-layout {
  display:flex;
  justify-content:center;
  a {
    
    &.active {
      background:#fff;
    }
    &:last-child:before {
      background-color: #fff;
      height: 2px;
      width: 25px;
      transform-origin: 0 0;
    }
    &:last-child:after {
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 0 5px 10px;
      border-color: transparent transparent transparent #fff;
    }
  }
}
.p-layout .more:hover::after {
  transform: scaleX(0) !important;
}

.p-layout a:last-child::before {
  background-color: @theme;
  height: 2px;
  width: 25px;
  transform-origin: 0 0;
}
.p-layout a:last-child::after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 0 5px 10px;
  border-color: transparent transparent transparent @theme;
}
</style>
